import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { ReviewPackage } from '@portal-core/reviews/review-packages/models/review-package.model';

@CollectionStateSelectors({
  stateType: ReviewPackagesState
})
@State<ReviewPackagesState>({
  name: ReviewPackagesState.source
})
@Service({ autoProvided: false })
export class ReviewPackagesState extends CollectionStateBase {
  static override source: string = 'ReviewPackages';

  getSource(): string {
    return ReviewPackagesState.source;
  }
}

@Service()
export class ReviewPackagesDataService extends CollectionDataServiceBase<ReviewPackage> {
  protected readonly stateType = ReviewPackagesState;
}
